var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEnter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.44 9.45999C15.4 9.36999 15.35 9.28994 15.28 9.21994L13.28 7.21994C12.99 6.92994 12.51 6.92994 12.22 7.21994C11.93 7.50994 11.93 7.98994 12.22 8.27994L12.94 8.99997H5.75C5.34 8.99997 5 9.33997 5 9.74997C5 10.16 5.34 10.5 5.75 10.5H12.94L12.22 11.2199C11.93 11.5099 11.93 11.9899 12.22 12.2799C12.37 12.4299 12.56 12.5 12.75 12.5C12.94 12.5 13.13 12.4299 13.28 12.2799L15.28 10.2799C15.35 10.2099 15.41 10.1299 15.44 10.0399C15.48 9.94995 15.5 9.84997 15.5 9.74997C15.5 9.64997 15.48 9.54999 15.44 9.45999Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 13C10.34 13 10 13.34 10 13.75V16.75C10 17.44 9.44 18 8.75 18H2.75C2.06 18 1.5 17.44 1.5 16.75V2.75C1.5 2.06 2.06 1.5 2.75 1.5H8.75C9.44 1.5 10 2.06 10 2.75V5.75C10 6.16 10.34 6.5 10.75 6.5C11.16 6.5 11.5 6.16 11.5 5.75V2.75C11.5 1.23 10.27 0 8.75 0H2.75C1.23 0 0 1.23 0 2.75V16.75C0 18.27 1.23 19.5 2.75 19.5H8.75C10.27 19.5 11.5 18.27 11.5 16.75V13.75C11.5 13.34 11.16 13 10.75 13Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnter);
export default __webpack_public_path__ + "static/media/icon-enter.fb1cd62dd21d65696a6a67a5f3e3b23d.svg";
export { ForwardRef as ReactComponent };